import { useQuery } from 'react-query';

import { getKeyActivitiesTags as queryFn } from 'api/endPoints/getKeyActivitiesTags';

export const useQueryGetKeyActivitiesTags = (params) => {
    return useQuery<{ id: number; contractId: number; tagId: number }[], QueryError>(
        ['getKeyActivitiesTags', params],
        () => queryFn(params),
        {
            enabled: Boolean(params.contractId),
        },
    );
};
